import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import { ShareDialog, VersionChecker } from '@meronex/components';
import { App } from '@meronex/app';

import IShare from '@meronex/icons/ri/RiShareForwardLine';
import ILight from '@meronex/icons/md/MdWbSunny';
import IMoon from '@meronex/icons/ri/RiMoonClearLine';
import PWAPrompt from 'react-ios-pwa-prompt';

function LinkLayout(props) {
  const {
    title,
    subtitle,
    shareUrl,
    children,
    showToggleTheme,
    onThemeChange,
    overflow,
    headerPosition,
  } = props;
  const [openShare, setOpenShare] = React.useState(false);
  const [themeType, setThemeType] = React.useState(App.themeType);

  React.useEffect(() => {
    if (onThemeChange) {
      onThemeChange(themeType);
    }
  }, []);

  const toggleTheme = () => {
    if (themeType === 'dark') {
      setThemeType('light');
      App.themeManager.changeTheme('light');
      if (onThemeChange) {
        onThemeChange('light');
      }
    } else {
      App.themeManager.changeTheme('dark');
      setThemeType('dark');
      if (onThemeChange) {
        onThemeChange('dark');
      }
    }
  };

  return (
    <div
      style={{
        fontFamily: 'Airbnb Cereal App Light',
        backgroundSize: 'cover',
        lineHeight: '1.5',
        paddingBottom: '20px',
        fontSize: '20px',
        overflow,
      }}>
      <div
        style={{
          margin: '10px',
          position: headerPosition,
        }}>
        <div
          style={{
            fontFamily: "'Airbnb Cereal App Bold'",
            fontSize: '25px',
            marginTop: '25px',
          }}>
          {title}
        </div>
        <div style={{ fontSize: '18px' }}>{subtitle}</div>
      </div>
      {children}
      {shareUrl && (
        <div
          style={{
            top: '20px',
            width: '40px',
            height: '40px',
            right: '20px',
            textAlign: 'center',
            position: 'absolute',
          }}>
          <IconButton
            onClick={() => {
              console.log('share');
              setOpenShare(true);
            }}>
            <IShare size={25} />
          </IconButton>
        </div>
      )}
      {showToggleTheme && (
        <div
          style={{
            top: '20px',
            width: '40px',
            height: '40px',
            right: shareUrl ? '70px' : '20px',
            textAlign: 'center',
            position: 'absolute',
          }}
          onClick={toggleTheme}>
          <IconButton aria-label="delete">
            {themeType === 'light' ? <IMoon /> : <ILight />}
          </IconButton>
        </div>
      )}

      <div />
      <ShareDialog
        open={openShare}
        onClose={() => {
          setOpenShare(false);
        }}
        showUrl
        showCopy
        data={{
          url: shareUrl,
          title,
          summary: subtitle,
        }}
      />
      <VersionChecker showChangelog={false} showHelperText={false} />
      <PWAPrompt
        promptOnVisit={1}
        timesToShow={7}
        delay={5000}
        permanentlyHideOnDismiss={false}
      />
    </div>
  );
}
LinkLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  shareUrl: PropTypes.string,
  showToggleTheme: PropTypes.bool,
  onThemeChange: PropTypes.func,
  overflow: PropTypes.string,
  headerPosition: PropTypes.string,
};

LinkLayout.defaultProps = {
  showToggleTheme: true,
  overflow: 'auto',
  headerPosition: 'inherit',
};
export default LinkLayout;
